import { EMRDynamicSearchEngineParms, EmrTreatmentRecord } from './../custom-sheet/custom-sheet.interface';
import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared';
import { PatientSheet } from '../custom-sheet/custom-sheet.interface';

import { CONFIG } from '../../shared/config';
import { simpleOrderService } from '../../orders/simple-order-request/simple-order-interfaces';
let medicalSheetsUrl = CONFIG.baseUrls.medicalSheets;

@Injectable()
export class PatientSheetService {
  CachtreatmentPlanMasterArr: any = [];
  constructor(private httpGeneralService: HttpGeneralService) { }

  savePatientSheets(PatientSheet: PatientSheet) {
    return this.httpGeneralService.add(PatientSheet, `${medicalSheetsUrl}/PatientSheets`);
  }
  GetEMRDynamicSearchEngineData(sheetParms: any[]) {
    return this.httpGeneralService.add(sheetParms, `${medicalSheetsUrl}/DynamicSearchEngineParms`);
  }
  patientSheetsItems(SheetParms: any) {
    return this.httpGeneralService.add(SheetParms, `${medicalSheetsUrl}/PatientSheetsItems`);
  }

  getDBList(SheetParms: any) {
    return this.httpGeneralService.add(SheetParms, `${medicalSheetsUrl}/PatientFormLoad`);
  }

  saveForm(FormData: any) {
    return this.httpGeneralService.add(FormData, `${medicalSheetsUrl}/PatientFormSave`);
  }
  saveEmrConsultation(FormData: any) {
    return this.httpGeneralService.add(FormData, `${medicalSheetsUrl}/EmrConsultationSave`);
  }
  getEmrConsultationLoad(FormData: any) {
    return this.httpGeneralService.add(FormData, `${medicalSheetsUrl}/getEmrConsultationLoad`);
  }

  UpdateReplayEmrConsultation(FormData: any[]) {
    return this.httpGeneralService.add(FormData, `${medicalSheetsUrl}/UpdateReplayEmrConsultation`);
  }

  deleteConsultatuion(serial: number) {
    return this.httpGeneralService.delete(serial, `${medicalSheetsUrl}`);
  }
  deleteClinicOrder(serial: number) {
    return this.httpGeneralService.delete(serial, `${medicalSheetsUrl}/deleteClinicOrder`);
  }

  deleteClinicNotes(serial: number) {
    return this.httpGeneralService.delete(serial, `${medicalSheetsUrl}/deleteClinicNotes`);
  }
  downloadExcelSheet(emrDynamicSearchEngineParms: EMRDynamicSearchEngineParms, responseType: string) {
    return this.httpGeneralService.getFileByPost(emrDynamicSearchEngineParms, `${medicalSheetsUrl}/ExportEMRDataToExcel`, responseType);
  }
  getEMRDownloadExcelURL() {
    return `${medicalSheetsUrl}/ExportEMRDataToExcel`
  }

  //------------------------------------ treatmentplan Area Start
  treatmentPlanCharge(secSecurityRoles: simpleOrderService) {
    return this.httpGeneralService.add(secSecurityRoles, `${medicalSheetsUrl}/TreatmentPlanCharge`)
  }
  treatmentPlanCancelCharge(secSecurityRoles: simpleOrderService) {
    return this.httpGeneralService.add(secSecurityRoles, `${medicalSheetsUrl}/TreatmentPlanCancelCharge`)
  }

  emrTreatmentPlanMasterSave(masterData: any) {
    return this.httpGeneralService.add(masterData, `${medicalSheetsUrl}/EmrTreatmentPlanMasterSave`);
  }
  deleteEmrTreatmentPlanMasterDelete(serial: number) {
    return this.httpGeneralService.delete(serial, `${medicalSheetsUrl}/EmrTreatmentPlanMasterDelete`);
  }

  emrTreatmentRecordLoad(emrTreatmentRecord: EmrTreatmentRecord) {
    return this.httpGeneralService.add(emrTreatmentRecord, `${medicalSheetsUrl}/EmrTreatmentRecordLoad`);
  }
  emrTreatmentRecordSave(emrTreatmentRecord: any[]) {
    return this.httpGeneralService.add(emrTreatmentRecord, `${medicalSheetsUrl}/EmrTreatmentRecordSave`);
  }
  emrTreatmentRecordDelete(serial: number) {
    return this.httpGeneralService.delete(serial, `${medicalSheetsUrl}/EmrTreatmentRecordDelete`);
  }
  getEmrTreatmentPlanDetails(EmrTreatmentPlanDetails: any) {
    return this.httpGeneralService.add(
      EmrTreatmentPlanDetails,
      `${medicalSheetsUrl}/getEmrTreatmentPlanDetails`
    );
  }
  //------------------------------------ treatmentplan Area End

}
